module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "dark",
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    attrs: {
      "id": "copyrights"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._v("\n\n      Copyrights © Terri Ann Creative, LLC. 2017 | All Rights Reserved\n\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e8338ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 108
// module chunks = 1